<template>
  <el-dialog  class="toTest_model_dialog" top="5vh" center
    :title="'其他任务-【' + formInfo.id + '】' + formInfo.title" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form size="mini" :model="formInfo">
      <el-form-item label="任务内容"  prop="context" :label-width="formLabelWidth" >
        <Editor   :content="formInfo.context"
                 :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <div style="display: flex">
        <el-form-item label="任务类型" :label-width="formLabelWidth">
          <div style="white-space: nowrap;">{{allSelect.OTHERTASHOPERATOR[formInfo.task_type]}}</div>
        </el-form-item>
        <el-form-item label="需求人" :label-width="formLabelWidth">
          <div style="white-space: nowrap;">{{ allSelect.TEXTUSERS[formInfo.demander] }}</div>
        </el-form-item>
        <el-form-item label="优先级" label-width="262px">
          <div style="white-space: nowrap;">{{formInfo.priority}}</div>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="负责人" label-width="187px">
          {{allSelect.TEXTALLUSERSEN[formInfo.leading]}}
        </el-form-item>
        <el-form-item label="计划开始日期" label-width="140px">
          {{ formatTimeToDate(formInfo.plt * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="计划完成日期" label-width="150px">
          {{ formatTimeToDate(formInfo.plet * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
      </div>
      <div style="display: flex;">
      <el-form-item label="状态" label-width="175px">
        {{ allSelect.OTHERTASKSTATUS[formInfo.status] }}
      </el-form-item>
      <el-form-item label="创建人" label-width="210px">
        <div style="white-space: nowrap;">{{allSelect.TEXTALLUSERSEN[formInfo.username]}}</div>
      </el-form-item>
      <el-form-item label="创建时间" label-width="165px">
        <div style="white-space: nowrap;">{{ formatTimeToDate(formInfo.create_time * 1, "YYYY-MM-DD HH:mm:ss") }}</div>
      </el-form-item>
      </div>
      <el-form-item label="我做了啥"  prop="details" :label-width="formLabelWidth" >
        <Editor   :content="formInfo.operator_context"
                  :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <el-form :model="formInfo" v-if="formInfo.id">
        <el-form-item class="comment_warp" label="评论" :model="formInfo" :label-width="formLabelWidth">
          <Comment  :tid="String(formInfo.id)" type="other_task" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="showButton()" type="primary" :loading="loading.submit" @click="submit('verify')">通 过</el-button>
      <el-button v-show="showButton()" type="warning" :loading="loading.submitpass" @click="submit('pass')">驳 回</el-button>
      <el-button type="primary" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
postDevOpsSpaceUpdateOtherTaskApi,
  getDevOpsSpaceOtherDetailApi,
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {Editor} from "@/components";
import {
  formatTimeToDate,
} from "@/views/tops/devOps/components/util.js";
import Comment from '@/views/tops/devOps/producerSpace/components/comment.vue'
export default {
  components: {Editor, Comment},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
      },
      formLabelWidth: "200px",
      loading: {
        submit: false,
        dialog: true,
        submitpass: false,
      }
    };
  },
  async created() {
    await this.getOtherDetailApi();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
  },
  methods: {
    showButton(){
      return this.formInfo.creator === this.formInfo.user;
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    async getOtherDetailApi() {
      const loginusername = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      const { id = "" } = this.formInfo || {};
      try {
        const ret = await getDevOpsSpaceOtherDetailApi({
          id: id,
        });
        const info = ret.data[0] || {};
        this.formInfo = {
          ...this.formInfo,
          demander: info.demander,
          creator: info.username,
          title: info.title,
          task_type: info.task_type,
          status: info.status,
          project_system: info.project_system,
          priority: info.priority,
          plt: info.plt,
          plet: info.plet,
          operator_context: info.operator_context,
          leading: info.leading,
          context: info.context,
          create_time: info.create_time,
          user: loginusername,
        };
      } catch (error) {
        this.$notify({
          message: error || "获取详情失败",
          type: "error",
        });
      }
    },
    // 提交
    async submit(action) {
      try {
        if(action === "verify"){
          this.loading.submit = true;
        }
        if(action === "pass"){
          this.loading.submitpass = true;
        }
        const loginusername = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
        const {
          id = "",
          title = "",
          leading = "",
          username = "",
        } = this.formInfo;
        const param = {
          id: id,
          leading: leading,
          creator: username,
          username: loginusername,
          flag: action,
          title: title,
        };
        const ret = await postDevOpsSpaceUpdateOtherTaskApi(param);
        let output = ret.data?.output || {};
        if (ret.status === 'success') {
          this.handleClose()
          this.$notify({
            message: ret.data?.msg || "提交成功",
            type: "success",
          });
        } else {
          this.$notify({
            message: ret.data.msg,
            type: 'error'
          })
        }
      } catch (error) {
        this.$notify({
          message: error || '提测失败',
          type: 'error'
        })
      } finally {
        if(action === "verify"){
          this.loading.submit = true;
        }
        if(action === "pass"){
          this.loading.submitpass = true;
        }

      }

    },
    formatTimeToDate,
  },
};
</script>
<style lang="scss">
.toTest_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
.el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
  line-height: 16px;
}
</style>